import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import logo from "../assets/logogg.png"; // adjust the path

export const generateInvoice = (txn, order) => {
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const pageWidth = doc.internal.pageSize.getWidth();

  // === Draw Circle and Logo (top-left) ===
  const centerX = 70; // circle center X
  const centerY = 55; // circle center Y
  const radius = 30;  // circle radius

  const img = new Image();
  img.src = logo;

  img.onload = () => {
    // Draw circle border
    doc.setDrawColor("#3C3C3B");
    doc.setLineWidth(2);
    doc.circle(centerX, centerY, radius, "S");

    // Maintain logo ratio
    const ratio = img.width / img.height;
    const maxLogoWidth = radius * 2 * 0.7;
    const maxLogoHeight = radius * 2 * 0.7;
    let logoWidth = maxLogoWidth;
    let logoHeight = logoWidth / ratio;

    if (logoHeight > maxLogoHeight) {
      logoHeight = maxLogoHeight;
      logoWidth = logoHeight * ratio;
    }

    const x = centerX - logoWidth / 2;
    const y = centerY - logoHeight / 2;
    doc.addImage(img, "PNG", x, y, logoWidth, logoHeight);

    // === Top Right Invoice Header ===
    doc.setFontSize(18);
    doc.text("INVOICE", pageWidth - 50, 40, { align: "right" });
    doc.setFontSize(12);
    doc.setFont(undefined, "bold");
    doc.text("Gasp Maker", pageWidth - 50, 60, { align: "right" });
    doc.setFont(undefined, "normal");
    doc.text("1861 NW 22nd St, Miami, FL 33142, UNITED STATES", pageWidth - 50, 76, { align: "right" });
    doc.text("gm@gaspmaker.com", pageWidth - 50, 92, { align: "right" });

    // === Info Box ===
    const boxY = 120;
    const boxHeight = 60;
    doc.setFillColor("#F4DBA7");
    doc.rect(40, boxY, pageWidth - 80, boxHeight, "F");

    doc.setFontSize(11);
    doc.setTextColor(0, 0, 0);
    doc.text(`Invoice No#: ${order.id}`, 50, boxY + 20);
    const dateStr = new Date(order.created_at || Date.now()).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
    doc.text(`Invoice Date: ${dateStr}`, 50, boxY + 40);

    doc.setFont(undefined, "bold");
    doc.setFontSize(14);
    doc.text(`$${Number(order.subtotal).toFixed(2)} USD`, pageWidth - 50, boxY + 25, { align: "right" });
    doc.setFontSize(11);
    doc.setFont(undefined, "normal");
    doc.text("Amount Due", pageWidth - 50, boxY + 45, { align: "right" });

    // === Bill To ===
    let yPos = boxY + boxHeight + 40;
    doc.setFontSize(12);
    doc.setFont(undefined, "bold");
    doc.text("Bill To:", 40, yPos);
    doc.setFont(undefined, "normal");
    yPos += 18;
    doc.text(`Customer: ${order.customer_name || "-"}`, 40, yPos);
    yPos += 16;
    doc.text(`WhatsApp: ${order.whatsapp || "-"}`, 40, yPos);
    yPos += 16;
    doc.text(`Address: ${order.address || "-"}`, 40, yPos);
    yPos += 16;
    doc.text(`Miles: ${order.miles ?? "-"}`, 40, yPos);
    yPos += 20;

    // === Order Table ===
    const rows = (order.boxes || []).map((b, i) => [
      i + 1,
      b.weight ?? "-",
      b.length ?? "-",
      b.width ?? "-",
      b.height ?? "-",
    ]);

    autoTable(doc, {
      startY: yPos,
      head: [["#", "Weight LBS", "Length", "Width", "Height"]],
      body: rows,
      theme: "grid",
      headStyles: { fillColor: [41, 128, 185] },
      styles: { fontSize: 10 },
    });

    // === Totals ===
    const tableEnd = doc.lastAutoTable.finalY + 20;
    const subtotal = Number(order.subtotal).toFixed(2);
    const total = subtotal;

    doc.setFont(undefined, "bold");
    doc.text(`Subtotal: $${subtotal}`, pageWidth - 50, tableEnd, { align: "right" });
    doc.setFontSize(14);
    doc.text(`Total: $${total}`, pageWidth - 50, tableEnd + 20, { align: "right" });

    // === Save ===
    doc.save(`invoice-${order.id}.pdf`);
  };
};

export default generateInvoice;
